import React from 'react';
import Carousel from 'react-material-ui-carousel';

import { Grid } from '@mui/material';
import { Button } from '@material-ui/core';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { makeStyles } from '@material-ui/core/styles';

import { COLOR_PRIMARY } from 'src/const';

const useStyles = makeStyles(theme => ({
  carouselDiv: {
    width: '100%',
  },
  navButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  navButton: {
    backgroundColor: 'transparent',
    color: COLOR_PRIMARY,
    position: 'relative',
  },
}));

const CarouselWrapper = ({
  data,
  visibleChildCount,
  CarouselContentElem,
  contentWidth,
  contentHeight,
  contentBorderRadius,
  contentSpacing,
  activeElement,
  setActiveElement,
  isMobile,
}) => {
  const classes = useStyles();

  const CarouselContentFrame = ({ dataFrame }) => {
    const contentFrameHeight = contentHeight * 1.5;

    return (
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{
          height: contentFrameHeight,
        }}
      >
        {dataFrame.map((item, i) => (
          <CarouselContentElem
            data={item}
            key={i}
            activeElement={activeElement}
            setActiveElement={setActiveElement}
            contentWidth={contentWidth}
            contentHeight={contentHeight}
            contentBorderRadius={contentBorderRadius}
            contentSpacing={contentSpacing}
          />
        ))}
      </Grid>
    );
  };

  let dataFrames = [] as any;
  const mutableDataCopy = [...data];
  while (mutableDataCopy.length > 0) dataFrames.push(mutableDataCopy.splice(0, visibleChildCount));

  return (
    <div className={classes.carouselDiv}>
      <Carousel
        NavButton={({ onClick, className, style, next, prev }) => {
          return (
            <Button onClick={() => onClick()} className={classes.navButton} style={style}>
              {next && <ArrowCircleRightOutlinedIcon sx={{ fontSize: '50px' }} />}
              {prev && <ArrowCircleLeftOutlinedIcon sx={{ fontSize: '50px' }} />}
            </Button>
          );
        }}
        navButtonsWrapperProps={{
          className: classes.navButtonWrapper,
        }}
        autoPlay={false}
        animation="slide"
        indicators={isMobile ? true : false}
        swipe={true}
        navButtonsAlwaysVisible={isMobile ? false : true}
        navButtonsAlwaysInvisible={isMobile ? true : false}
        cycleNavigation={false}
        fullHeightHover={false}
      >
        {dataFrames.map((dataFrame, i) => (
          <CarouselContentFrame dataFrame={dataFrame} key={i} />
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselWrapper;
